import React, { useState, useEffect } from 'react';
import styles from './chartt.module.scss';
import Chart from 'chart.js/auto';
import { ChartConfiguration } from 'chart.js';


function Chartt(props:any) {

  const [drawInitial] = useState(0);
  const [theme, setTheme] = useState('T');
  const containerDoughnut = React.useRef<any>();
  const containerLine = React.useRef<any>();
  const containerBar = React.useRef<any>();
  const graphMain = React.useRef<any>();
  const headerMain = React.useRef<any>();


  useEffect(() => {
   
    if(props.state.selected !=='charts') {
      const clonedState = Object.assign({},props.state);
      clonedState.selected = 'charts'
      props.stateChanger(clonedState);
  
    }


    return () => { }
  } );






  useEffect(() => {
    let scheduledIntervalDoughnut: any;
    let scheduledIntervalLines: any;
    let scheduledIntervalBars: any;
    const drawDoughnut = (dataA: any) => {

      const canvasGraph = document.createElement('canvas');
      canvasGraph.id = "myChart";
      canvasGraph.height = 300;
      containerDoughnut.current.appendChild(canvasGraph);
      const data = {
        labels: [
          'Frontend',
          'Backend',
          'Management',
          'Cloud',
          'Devops',
          'Designers',
          'SalesPersons',
          'Interpreters',
          'Speakers',
          'Crm Ex',
          'Ctos',
          'Office',
          'Hr',
          'Directors',
          'Helpdesk'

        ],
        datasets: [{
          label: 'AAAAAAAAAAAA',
          data: dataA,
          backgroundColor: [
            'blue',
            'yellow',
            'green',
            'rgb(51, 0, 0)',
            'red',
            'black',
            'pink',
            'olive',
            'rgb(51, 51, 51)',
            'rgb(51, 251, 1)',
            'rgb(151, 8, 211)',
            'rgb(6, 100, 50)',
            'rgb(16, 200, 80)',
            'rgb(61, 18, 50)',
            'rgb(16, 90, 4)',
          ],
          hoverOffset: 4
        }]
      };



      const myChart = new Chart(
        canvasGraph,
        {
          type: 'doughnut',
          data: data,
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Data Projection of workforce'
              }
            }
          },
        }
      );

      scheduledIntervalDoughnut = setInterval(() => {
        const min = 0;
        const max = 100;
        for (let i = 0; i < myChart.data.datasets[0].data.length; i++) myChart.data.datasets[0].data[i] = Math.random() * (max - min + 1) + min
        myChart.update();

      }, 5000);

    }
    const drawLines = (dataA: any) => {

      const canvasGraph = document.createElement('canvas');
      canvasGraph.id = "myChart1";
      canvasGraph.height = 300;
      containerLine.current.appendChild(canvasGraph);
      const data = {
        labels: [
          'Frontend',
          'Backend',
          'Management',
          'Cloud',
          'Devops',
          'Designers',
          'SalesPersons',
          'Interpreters',
          'Speakers',
          'Crm Ex',
          'Ctos',
          'Office',
          'Hr',
          'Directors',
          'Helpdesk'

        ],
        datasets: [{
          label: 'Dataset 1',
          data: dataA,
          backgroundColor: [
            'blue',
            'yellow',
            'green',
            'rgb(51, 0, 0)',
            'red',
            'black',
            'pink',
            'olive',
            'rgb(51, 51, 51)',
            'rgb(51, 251, 1)',
            'rgb(151, 8, 211)',
            'rgb(6, 100, 50)',
            'rgb(16, 200, 80)',
            'rgb(61, 18, 50)',
            'rgb(16, 90, 4)',
          ],
          hoverOffset: 4
        }]
      };

      const config: ChartConfiguration = {
        type: 'line',
        data: data,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
            },
            title: {
              display: true,
              text: 'Data Projection of workforce'
            }
          }
        }
      };

      const myChart = new Chart(
        canvasGraph,
        config
      );

      scheduledIntervalLines = setInterval(() => {
        const min = 0;
        const max = 100;
        for (let i = 0; i < myChart.data.datasets[0].data.length; i++) myChart.data.datasets[0].data[i] = Math.random() * (max - min + 1) + min
        myChart.update();

      }, 5000);





    }
    const drawBars = (dataA: any) => {

      const canvasGraph = document.createElement('canvas');
      canvasGraph.id = "myChart2";
      canvasGraph.height = 300;
      containerBar.current.appendChild(canvasGraph);
      const data = {
        labels: [
          'Frontend',
          'Backend',
          'Management',
          'Cloud',
          'Devops',
          'Designers',
          'SalesPersons',
          'Interpreters',
          'Speakers',
          'Crm Ex',
          'Ctos',
          'Office',
          'Hr',
          'Directors',
          'Helpdesk'

        ],
        datasets: [{
          label: 'Data Projection of workforce',
          data: dataA,
          backgroundColor: [
            'blue',
            'yellow',
            'green',
            'rgb(51, 0, 0)',
            'red',
            'black',
            'pink',
            'olive',
            'rgb(51, 51, 51)',
            'rgb(51, 251, 1)',
            'rgb(151, 8, 211)',
            'rgb(6, 100, 50)',
            'rgb(16, 200, 80)',
            'rgb(61, 18, 50)',
            'rgb(16, 90, 4)',
          ],
          hoverOffset: 4
        }]
      };

      const config: ChartConfiguration = {
        type: 'bar',
        data: data,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
            },
            title: {
              display: true,
              text: 'Data Projection of workforce'
            }
          }
        }
      };


      const myChart = new Chart(
        canvasGraph,
        config
      );

      scheduledIntervalBars = setInterval(() => {
        const min = 0;
        const max = 100;
        for (let i = 0; i < myChart.data.datasets[0].data.length; i++) myChart.data.datasets[0].data[i] = Math.random() * (max - min + 1) + min
        myChart.update();

      }, 5000);

    }

    drawDoughnut([5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 10, 15, 15, 5]);
    drawLines([2, 3, 4, 3, 2, 6, 12, 3, 5, 7, 20, 18, 16, 12, 100]);
    drawBars([2, 3, 4, 3, 2, 6, 12, 3, 5, 7, 20, 18, 16, 12, 100]);


    return () => {
      if (scheduledIntervalDoughnut) clearInterval(scheduledIntervalDoughnut);
      if (scheduledIntervalLines) clearInterval(scheduledIntervalLines);
      if (scheduledIntervalBars) clearInterval(scheduledIntervalBars);
    }


  }, [drawInitial]);

  useEffect(() => {
    graphMain.current.style.backgroundColor = theme === 'T' ? 'rgb(162, 191, 220)' : 'rgb(162, 191, 255)';
    headerMain.current.style.backgroundColor = theme === 'T' ? 'rgb(162, 191, 220)' : 'rgb(162, 191, 255)';
    return () => { }
  }, [theme]);




  return (
    <React.Fragment>
   
      <div ref={headerMain} className={styles.header}>
        <div>REALTIME chart.js in React by Diego Burlando</div>
        <div style={{ paddingLeft: '1%' }}><button title="toggle theme" className={styles.themeButton} onClick={() => { setTheme(theme === 'T' ? 'D' : 'T') }}>t</button></div>
      </div>
      <div ref={graphMain} className={styles.container} >
        <div ref={containerDoughnut} className={styles.graph1} ></div>
        <div ref={containerLine} className={styles.graph1} id="container-graphs-lines"></div>
        <div ref={containerBar} className={styles.graph1} id="container-graphs-bars"></div>
      </div>

    </React.Fragment>
  )
}


export default Chartt;